var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77186 11.9343C5.61331 10.92 7.66886 10.0734 9.58948 9.22255C12.8937 7.82886 16.211 6.45932 19.5618 5.18429C20.2138 4.96704 21.3851 4.75458 21.5 5.72073C21.4371 7.0883 21.1784 8.44786 21.0009 9.80743C20.5505 12.7972 20.0298 15.7768 19.5222 18.7568C19.3472 19.7494 18.1038 20.2632 17.3082 19.628C15.3961 18.3364 13.4693 17.0575 11.5816 15.736C10.9633 15.1077 11.5367 14.2054 12.0889 13.7567C13.6638 12.2047 15.3339 10.8861 16.8265 9.25386C17.2291 8.28161 16.0395 9.101 15.6471 9.35205C13.4911 10.8378 11.3879 12.4142 9.11487 13.7199C7.95378 14.3591 6.60052 13.8129 5.43996 13.4562C4.39937 13.0254 2.87453 12.5913 3.77176 11.9344L3.77186 11.9343Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.3f8a45d798dbb3da31f94fd633f33572.svg";
export { ForwardRef as ReactComponent };